webpackJsonp([55702396619907],{

/***/ 368:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"group":[{"fieldValue":"brewing","totalCount":1},{"fieldValue":"chemex","totalCount":1},{"fieldValue":"docs","totalCount":1},{"fieldValue":"flavor","totalCount":2},{"fieldValue":"git","totalCount":1},{"fieldValue":"green beans","totalCount":1},{"fieldValue":"jamaica","totalCount":1},{"fieldValue":"tasting","totalCount":2}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-ba1c5e0aa3cce387505c.js